"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStateWithObservable = exports.useReplaySubjectWithObservable = exports.useBehaviorSubjectWithObservable = exports.useSubjectWithObservable = exports.useReplaySubject = exports.useImmerBehaviorSubject = exports.useBehaviorSubject = exports.useSubject = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const use_immer_1 = require("use-immer");
function useSubject() {
    const [subject, setSubject] = (0, react_1.useState)();
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.Subject(), []);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, setSubject, subject$];
}
exports.useSubject = useSubject;
function useBehaviorSubject(defaultValue) {
    const [subject, setSubject] = (0, react_1.useState)(defaultValue);
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.BehaviorSubject(defaultValue), [defaultValue]);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, setSubject, subject$];
}
exports.useBehaviorSubject = useBehaviorSubject;
function useImmerBehaviorSubject(defaultValue) {
    const [subject, setSubject] = (0, use_immer_1.useImmer)(defaultValue);
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.BehaviorSubject(defaultValue), [defaultValue]);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, setSubject, subject$];
}
exports.useImmerBehaviorSubject = useImmerBehaviorSubject;
function useReplaySubject(bufferSize, windowTime, timestampProvider) {
    const [subject, setSubject] = (0, react_1.useState)();
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.ReplaySubject(bufferSize, windowTime, timestampProvider), [bufferSize, windowTime, timestampProvider]);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, setSubject, subject$];
}
exports.useReplaySubject = useReplaySubject;
function useSubjectWithObservable(observable) {
    const [subject, setSubject] = (0, react_1.useState)();
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.Subject(), []);
    (0, react_1.useEffect)(() => {
        const subscribe = observable.subscribe({
            next: setSubject,
        });
        return () => {
            subscribe.unsubscribe();
        };
    }, [observable]);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, subject$];
}
exports.useSubjectWithObservable = useSubjectWithObservable;
function useBehaviorSubjectWithObservable(observable, defaultValue) {
    const [subject, setSubject] = (0, react_1.useState)(defaultValue);
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.BehaviorSubject(defaultValue), [defaultValue]);
    (0, react_1.useEffect)(() => {
        const subscribe = observable.subscribe({
            next: setSubject,
        });
        return () => {
            subscribe.unsubscribe();
        };
    }, [observable]);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, subject$];
}
exports.useBehaviorSubjectWithObservable = useBehaviorSubjectWithObservable;
function useReplaySubjectWithObservable(observable, bufferSize, windowTime, timestampProvider) {
    const [subject, setSubject] = (0, react_1.useState)();
    const subject$ = (0, react_1.useMemo)(() => new rxjs_1.ReplaySubject(bufferSize, windowTime, timestampProvider), [bufferSize, windowTime, timestampProvider]);
    (0, react_1.useEffect)(() => {
        const subscribe = observable.subscribe({
            next: setSubject,
        });
        return () => {
            subscribe.unsubscribe();
        };
    }, [observable]);
    (0, react_1.useEffect)(() => {
        if (subject) {
            subject$.next(subject);
        }
    }, [subject, subject$]);
    return [subject, subject$];
}
exports.useReplaySubjectWithObservable = useReplaySubjectWithObservable;
function useStateWithObservable(observable, defaultValue) {
    const [state, setState] = (0, react_1.useState)(defaultValue);
    (0, react_1.useEffect)(() => {
        const subscribe = observable.subscribe({
            next: setState,
        });
        return () => {
            subscribe.unsubscribe();
        };
    }, [observable]);
    return state;
}
exports.useStateWithObservable = useStateWithObservable;
